import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ParametrosService, Sx_Configuration } from '../../infrastructure/services/parametros.service';

@Component({
  selector: 'sx-add-parametro',
  templateUrl: 'parametro.crear.component.html'
})
export class ParametroCrearComponent implements OnInit {
  estaEditando = false;
  parametro: Sx_Configuration;
  private _data: Sx_Configuration;

  @Output() save: EventEmitter<any> = new EventEmitter();
  @Output() cancel: EventEmitter<any> = new EventEmitter();

  @Input() set data(value: Sx_Configuration) {
    this._data = value;
    if (value) {
      this.estaEditando = true;
    }
    this.inicializarParametro();
  }

  get data(): Sx_Configuration {
    return this._data;
  }

  constructor(private parametrosService: ParametrosService) { }

  ngOnInit() {
    this.inicializarParametro();
  }

  guardar() {
    this.parametrosService.crearOEditar(this.parametro)
      .then(success => {
        this.estaEditando = false;
        this.inicializarParametro();
        this.save.emit();
      });
  }

  cancelar() {
    this.inicializarParametro();
    this.cancel.emit();
  }

  private inicializarParametro() {
    if (this._data) {
      this.parametro = {
        key: this._data.key,
        value: this._data.value,
        descripcion: this._data.descripcion,
      };

      return;
    }
  
    this.parametro = {
      key: '',
      value: '',
      descripcion: '',
    };
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/parametros/parametro.crear.component.ts